import React from 'react';
import { COLOR } from '@src/styles/color';
import Typography from '@src/new-components/Typography';
import { useTranslation } from 'react-i18next';
import { StyledSentences } from './index.style';

const Sentences = () => {
  const { i18n, t } = useTranslation();
  const { language } = i18n;

  // TODO: get sentences from backend
  const sentences = {
    vi: 'Nhóm nghiên cứu đã phát triển hướng nghiên cứu thiết kế, chế tạo, và chức năng hoá chủng loại vật liệu Nano xốp có khả năng phân huỷ sinh học ứng dụng trong nhiều lĩnh vực y sinh ',
    en: 'The research group has developed a research direction of designing, manufacturing, and functionalizing the porous Nano material with biological degradation ability applied in many fields of life science',
  };

  return (
    <StyledSentences>
      <div style={{ textAlign: 'center' }}>
        <Typography
          component="p"
          textTransform="uppercase"
          color={COLOR.descriptionUpload}
          variant="body-14-medium"
        >
          {t('readTheSentence')}
        </Typography>
      </div>
      <div style={{ marginTop: '16px' }}>
        <Typography
          component="p"
          variant="body-20-medium"
          color={COLOR.darkGray}
          gutterBottom
        >
          {sentences[language]}
        </Typography>
      </div>
    </StyledSentences>
  );
};

export default Sentences;
